// Red cross shown on the /failed pages (inline SVG so no extra asset has to be deployed).
export const FAILED_ICON =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 96 96'>" +
      "<circle cx='48' cy='48' r='44' fill='#e53935'/>" +
      "<path d='M32 32l32 32M64 32L32 64' stroke='#fff' stroke-width='9' stroke-linecap='round'/>" +
      "</svg>"
  );
